import { useLookbookNavigationSettingsContext } from '@app/components/lookbook/LookbookSettingsModal/LookbookNavigationSettingsContext';
import { getIsFolderNavigationItem, getIsLinkNavigationItem } from '@app/logic/lookbook';
import { isDefined } from '@app/utils/is';
import { isEmpty } from 'ramda';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const useLookbookNavigationValidation = () => {
  const { t } = useTranslation(['settings']);
  const { itemRecords, pagesRecords } = useLookbookNavigationSettingsContext();

  const canNest = React.useCallback(
    (activeItemId: string, parentId: Nullable<string>) => {
      if (!isDefined(parentId)) {
        return {
          isValid: true,
        };
      }

      const activeItem = itemRecords[activeItemId];
      const parentItem = itemRecords[parentId];

      if (!isDefined(activeItem) || !isDefined(parentItem)) {
        return {
          isValid: false,
        };
      }

      const isActiveItemFolder = getIsFolderNavigationItem(activeItem);
      const isItemHasChildren = isDefined(activeItem.children) && !isEmpty(activeItem.children);

      if (isActiveItemFolder || isItemHasChildren) {
        return {
          isValid: false,
          message: t('settings:cant_nest_folder'),
        };
      }

      const isParentLink = getIsLinkNavigationItem(parentItem);
      if (isParentLink) {
        return {
          isValid: false,
          message: t('settings:cant_nest_link'),
        };
      }

      return { isValid: true };
    },
    [itemRecords, pagesRecords, t],
  );

  return { canNest };
};
